namespace appn.views.brandCenter.screenShots {
    class InitArgs {
        brandCenterDeleteScreenShot: string = emptyString;
    }

    let _initArgs: InitArgs;

    export function init(args: InitArgs): void {
        _initArgs = args;

        addEvents();
    }

    function addEvents(): void {
        $('.btnAddScreenshot').off().on('click', function(event) {
            event.preventDefault();
            $(this).hide();
            $(this).closest('.image-col').find('.fileinput.fileinput-new').removeClass('hide');
        });

        $('.btn-fileupload-deleteFile').click(function(event) {
            event.preventDefault();

            if ($(this).attr('disabled') || event.target.hasAttribute('disabled'))
                return;

            const currentImageCol = $(this).closest('.image-col');

            appn.dialog.confirm({
                modalColor: 'modal-danger',
                title: appn.strings.deleteTitle,
                message: T('This screenshot will be permanently deleted.<br />Are you sure you want to delete this screenshot?<br /><br />Click <b>OK</b> to delete.'),
                buttons: {
                    confirm: {
                        label: '<span>' + T('OK') + '</span>',
                        className: 'btn-success'
                    }
                },
                className: appn.emptyString,
                isDeleteAction: true,
                callback: function(result: any) {
                    if (result) {
                        appn.dialog.showLoading();

                        const data = {
                            deviceOs: currentImageCol.data('deviceos'),
                            formFactor: currentImageCol.data('formfactor'),
                            screenytIndexToDelete: currentImageCol.data('screenytindextodelete'),
                            providerId: currentImageCol.data('providerid')
                        };

                        $.ajax({
                            headers: appn.verifyHeader,
                            url: _initArgs.brandCenterDeleteScreenShot,
                            data: data,
                            success: function(jqXHR, textStatus, errorThrown) {
                                appn.location.reloadCurrentPage();
                            },
                            contentType: 'application/x-www-form-urlencoded; charset=utf-8',
                            dataType: 'json',
                            type: 'POST',
                            cache: false,
                            error: function(jqXHR, textStatus, errorThrown) {
                                appn.dialog.hideLoading();

                                if (!errorThrown || textStatus === 'parsererror')
                                    errorThrown = appn.strings.errorRetrievingData;
                                appn.toast.notify(toast.Type.error, errorThrown);
                            }
                        });
                    }
                }
            });
        });
    }
}
